import React from "react";

class HubspotForm extends React.Component {
    componentDidMount() {
        const script = document.createElement('script');
      script.src = 'https://js.hsforms.net/forms/v2.js';
      document.body.appendChild(script);
      
      script.addEventListener('load', () => {
          if(window.hbspt) {
            window.hbspt.forms.create({
              /*portalId: '8463263',
            formId: 'eacefea5-fec2-4293-8763-c74a30acf4b8',*/
            portalId: this.props.pid,
            formId: this.props.fid,
            target: '#hubspotForm'
          })
        }
      });
    }
    
      render() {
        return (
            <div>
              <div id="hubspotForm"></div>
            </div>
      );
    }
  }

export default HubspotForm;